import { createSlice } from "@reduxjs/toolkit";
import { IUser } from "src/@types/users";
import {
  getCurrentUserReducer,
  clearCurrentUserReducer,
  updateCurrentUserReducer,
} from "./reducers";
import { CURRENT_USER_SLICE_NAME } from "./actions";

export interface CurrentUserState {
  isLoading: boolean;
  isLoadingUpdate: boolean;
  isAuthorized: boolean;
  currentUser: IUser;
}

const initialState: CurrentUserState = {
  isLoading: true,
  isLoadingUpdate: false,
  isAuthorized: false,
  currentUser: null,
};

export const { reducer: currentUser } = createSlice({
  name: CURRENT_USER_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    getCurrentUserReducer(builder);
    updateCurrentUserReducer(builder);
    clearCurrentUserReducer(builder);
  },
});
